import { render, staticRenderFns } from "./CustomerSelector.vue?vue&type=template&id=8502cda4&"
import script from "./CustomerSelector.vue?vue&type=script&lang=js&"
export * from "./CustomerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8502cda4')) {
      api.createRecord('8502cda4', component.options)
    } else {
      api.reload('8502cda4', component.options)
    }
    module.hot.accept("./CustomerSelector.vue?vue&type=template&id=8502cda4&", function () {
      api.rerender('8502cda4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customer/CustomerSelector.vue"
export default component.exports